<template>
    <header class="fixed inset-x-0 top-0 z-20">
        <div ref="topBarRef" class="flex">
            <a href="https://camaq.org/" target="_blank" rel="noopener noreferrer" class="btn-top-bar btn-top-bar--light w-1/3 text-xs sm:text-sm">
                <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" class="hidden shrink-0 sm:block">
                    <circle cx="12" cy="12" r="10" stroke="white" stroke-width="1.5" />
                    <path d="M2 12h20M12 2c2.5 2.6 4 6.2 4 10s-1.5 7.4-4 10c-2.5-2.6-4-6.2-4-10s1.5-7.4 4-10z" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                </svg>
                <span>camaq.org</span>
            </a>
            <a href="https://deplacedelair.ca/" target="_blank" rel="noopener noreferrer" class="btn-top-bar btn-top-bar--dark w-1/3 text-xs sm:text-sm">
                <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" class="hidden shrink-0 sm:block">
                    <path d="M21 4L3 11l7 3m11-10l-4 16-7-6m11-10L10 14" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                </svg>
                <span>deplacedelair.ca</span>
            </a>
            <a href="https://aeroweb.ca/connexion" target="_blank" rel="noopener" class="btn-top-bar btn-top-bar--light w-1/3 text-xs sm:text-sm">
                <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" class="hidden shrink-0 sm:block">
                    <rect x="3" y="7" width="18" height="13" rx="2" stroke="white" stroke-width="1.5" />
                    <path d="M8 7V5a2 2 0 012-2h4a2 2 0 012 2v2M12 11v4M10 13h4" stroke="white" stroke-width="1.5" stroke-linecap="round" />
                </svg>
                <span>{{ $t('Publish a job opportunity') }}</span>
            </a>
        </div>

        <template v-if="props.isSubdomain">
            <div class="bg-white p-4 shadow">
                <div class="mx-auto max-w-6xl">
                    <div class="flex items-center justify-between">
                        <h1 class="text-2xl font-extrabold">
                            <a :href="`${pageProps.appUrl}`">
                                <img src="/images/logos/camaq.webp" alt="CAMAQ" class="h-16 w-40 object-contain" />
                            </a>
                        </h1>
                        <nav>
                            <a :href="`${pageProps.appUrl}`" class="link">
                                {{ $t('Return to CAMAQ') }}
                            </a>
                        </nav>
                    </div>
                </div>
            </div>
        </template>

        <template v-else>
            <MobileNavigation class="lg:hidden" />
            <DesktopNavigation class="hidden lg:block" :scrolled="scrolled" />
        </template>
    </header>
</template>

<script setup>
    import DesktopNavigation from './DesktopNavigation';
    import MobileNavigation from './MobileNavigation';
    import { computed, onBeforeUnmount, onMounted, ref } from 'vue';
    import { usePage } from '@inertiajs/inertia-vue3';

    const props = defineProps({
        isSubdomain: {
            type: Boolean,
            default: false,
        },
    });

    const topBarRef = ref(null);
    const scrolled = ref(false);

    onMounted(() => {
        window.addEventListener('scroll', onScroll);
    });

    onBeforeUnmount(() => {
        window.removeEventListener('scroll', onScroll);
    });

    function onScroll() {
        scrolled.value = window.scrollY > 50;

        if (topBarRef.value) {
            if (scrolled.value) {
                topBarRef.value.classList.add('hidden');
            } else {
                topBarRef.value.classList.remove('hidden');
            }
        }
    }

    const pageProps = computed(() => {
        return usePage().props.value;
    });
</script>
